// extracted by mini-css-extract-plugin
export default {"page":"LayoutDefault__page___qEsfT","container":"LayoutDefault__container____mnDM"};